import React from 'react';
import Button from './Button';
import DialogInput from '../advanced/DialogInput';
import MinusAndPlusInput from './MinusAndPlusInput';
import LOOKUP from 'constants/lookup';

class printLabelDialog extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            printLabelDialog: false
        }
    }

    componentWillReceiveProps(newProps){
        if(newProps.open !== this.props.printLabelDialog && typeof(newProps.open) === "boolean"){
            this.setState({ printLabelDialog: newProps.open });
        }
    }

    closePrintLabelDialog = () => {
        this.setState( p => {
            return {
                ...p,
                printLabelDialog: false 
            }
        });
        this.props.clearPrintQuantity("labelQuantityProductBarcode");
    }

    render(){
        return (
            <DialogInput
                title={LOOKUP.product.printLabelDialog.title}
                actions={[
                    <Button
                        key={1}
                        type="CancelButton"
                        name="buttonCancel"
                        className="btn-space"
                        label={LOOKUP.common.cancel.text}
                        onTouchTap={this.closePrintLabelDialog} />,
                    <Button
                        key={2}
                        name="ConfirmButton"
                        label={LOOKUP.product.printLabelDialog.print.label}
                        onTouchTap={() => this.props.printLabel('Z'+(`00000000000${this.props.product.id}`).slice(-11), 1, this.props.product.price)}
                        primary={true}
                    />]}
                modal={true}
                className="printLabelProduct"
                open={this.state.printLabelDialog}
            >
                <div className="row d-flex justify-content-center">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <MinusAndPlusInput
                            name="labelQuantityProductBarcode"
                            minimum="1"
                            maximum="100"
                        />
                    </div> {/* .col */}
                </div> {/* .row */}
            </DialogInput>
        );
    }
}

export default printLabelDialog;